module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_up_gray600-34f46d360a4127471901dfd034f182e5.svg";